import format from 'date-fns/format';
import formatISO from 'date-fns/formatISO';

import { type DatePartition } from '../common/types';

const partitionDate = (date: Date): DatePartition => {
	return {
		day: date.getDate(),
		hour: date.getHours(),
		minute: date.getMinutes(),
		month: date.getMonth(),
		year: date.getFullYear(),
	};
};

const formatting = {
	/**
	 * Formats date to date hour minute string
	 * @param date - Date | number
	 * @return time - string - Ex. '2024/08/21 08:00'
	 */
	toDateHourMinute: (date: Date | number | string): string => {
		if (typeof date === 'string') {
			date = new Date(date);
		}

		return format(date, 'yyyy/MM/dd HH:mm');
	},
	/**
	 * Formats date to ISO string
	 * @param date - Date | number
	 * @return time - string - Ex. '2024-08-21T08:00:00+00:00'
	 */
	toISO: (date: Date | number | string): string => {
		if (typeof date === 'string') {
			date = new Date(date);
		}

		return formatISO(date);
	},
};

export { partitionDate, formatting };
